import _assign from "object-assign";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef, Children, useMemo } from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import classnames from 'classnames';
import { useDensity, withStyles } from '@jpmuitk/theme';
import ButtonBarContext from './internal/ButtonBarContext';
import { DescendantProvider } from './internal/DescendantContext';
import useDescendants from './internal/useDescendants';
import { buttonBarStyle } from './style';
export var DefaultButtonsOrderByVariant = {
  cta: {
    order: 0,
    alignLeftOrder: 1,
    stackOrder: 2
  },
  regular: {
    order: 1,
    alignLeftOrder: 2,
    stackOrder: 1
  },
  secondary: {
    order: 2,
    alignLeftOrder: 0,
    stackOrder: 0
  }
};

function getPriorityForButton(item, field) {
  var variant = item && item.variant || 'regular';
  return item && item[field] !== undefined ? item[field] : DefaultButtonsOrderByVariant[variant][field];
}

var createComparatorForField = function createComparatorForField(field, sort, alignLeft, childrenData) {
  var equalityResult;

  if (field === 'order' || field === 'stackOrder') {
    equalityResult = sort === 'asc' ? 1 : 0;
  } else {
    equalityResult = alignLeft ? 1 : -1;
  }

  function createDescComparator(indexA, indexB) {
    var priorityA = getPriorityForButton(childrenData[indexA], field);
    var priorityB = getPriorityForButton(childrenData[indexB], field);

    if (priorityA == null && priorityB == null) {
      return 0;
    }

    if (priorityA == null) {
      return 1;
    }

    if (priorityB == null) {
      return -1;
    }

    if (priorityA === priorityB) {
      return equalityResult;
    }

    return priorityB - priorityA;
  }

  function createAscComparator() {
    return createDescComparator.apply(void 0, arguments) * -1;
  }

  return sort === 'asc' ? createAscComparator : createDescComparator;
};

function alignSecondaryChild(orderedChildrenData, sortOrder, alignLeft) {
  var noSecondaryChildren = {
    index: undefined,
    align: undefined
  };

  if (sortOrder === 'asc' || alignLeft) {
    var firstSecondaryChildIndex = orderedChildrenData.findIndex(function (childData) {
      return childData.variant === 'secondary';
    });

    if (firstSecondaryChildIndex !== -1) {
      var originalChildIndex = orderedChildrenData[firstSecondaryChildIndex].index;
      return {
        index: originalChildIndex,
        align: 'right'
      };
    } else {
      return noSecondaryChildren;
    }
  } else {
    var index = orderedChildrenData.length;

    while (index--) {
      if (orderedChildrenData[index].variant === 'secondary') {
        return {
          index: orderedChildrenData[index].index,
          align: 'left'
        };
      }
    }

    return noSecondaryChildren;
  }
}

var ButtonBar = /*#__PURE__*/forwardRef(function ButtonBar(props, ref) {
  var _classnames;

  var alignLeft = props.alignLeft,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      densityProp = props.density,
      disableAutoAlignment = props.disableAutoAlignment,
      _props$sortAlignLeft = props.sortAlignLeft,
      sortAlignLeft = _props$sortAlignLeft === void 0 ? 'desc' : _props$sortAlignLeft,
      _props$sortOrder = props.sortOrder,
      sortOrder = _props$sortOrder === void 0 ? 'desc' : _props$sortOrder,
      _props$sortStackOrder = props.sortStackOrder,
      sortStackOrder = _props$sortStackOrder === void 0 ? 'desc' : _props$sortStackOrder,
      _props$stackAtBreakpo = props.stackAtBreakpoint,
      stackAtBreakpoint = _props$stackAtBreakpo === void 0 ? 'xs' : _props$stackAtBreakpo,
      theme = props.theme,
      rest = _objectWithoutProperties(props, ["alignLeft", "children", "classes", "className", "density", "disableAutoAlignment", "sortAlignLeft", "sortOrder", "sortStackOrder", "stackAtBreakpoint", "theme"]);

  var _useDescendants = useDescendants(),
      _useDescendants2 = _slicedToArray(_useDescendants, 2),
      childrenData = _useDescendants2[0],
      setChildrenData = _useDescendants2[1];

  var density = useDensity(densityProp);
  var matches = useMediaQuery(theme.breakpoints.down(stackAtBreakpoint));
  var childrenArray = Children.toArray(childrenProp);
  var childrenIndexes = childrenArray.map(function (_, index) {
    return index;
  });
  var stackOrderComparator = createComparatorForField('stackOrder', sortStackOrder, alignLeft, childrenData);
  var orderComparator = createComparatorForField('order', sortOrder, alignLeft, childrenData);
  var alignLeftComparator = createComparatorForField('alignLeftOrder', sortAlignLeft, alignLeft, childrenData);
  var orderedChildrenIndexes;

  if (childrenData.length !== childrenIndexes.length) {
    orderedChildrenIndexes = childrenIndexes;
  } else {
    orderedChildrenIndexes = matches ? childrenIndexes.sort(stackOrderComparator) : childrenIndexes.sort(alignLeft ? alignLeftComparator : orderComparator);
  }

  var secondaryChildAlignment = {
    index: undefined,
    align: undefined
  };

  if (!disableAutoAlignment) {
    secondaryChildAlignment = alignSecondaryChild(orderedChildrenIndexes.map(function (index) {
      return _assign({
        index: index
      }, childrenData[index]);
    }), sortOrder, alignLeft);
  }

  var hasSecondaryButtons = childrenData.some(function (buttonData) {
    return buttonData.variant === 'secondary';
  });
  var orderedChildren = orderedChildrenIndexes.map(function (index) {
    return childrenArray[index];
  });
  var buttonBarContext = useMemo(function () {
    return {
      density: density,
      matches: matches,
      alignedIndex: secondaryChildAlignment.index,
      align: secondaryChildAlignment.align
    };
  }, [density, matches, secondaryChildAlignment.align, secondaryChildAlignment.index]);
  return /*#__PURE__*/React.createElement(ButtonBarContext.Provider, {
    value: buttonBarContext
  }, /*#__PURE__*/React.createElement(DescendantProvider, {
    items: childrenData,
    setItems: setChildrenData
  }, /*#__PURE__*/React.createElement("div", _assign({
    "aria-label": "button bar",
    className: classnames(className, classes.root, (_classnames = {}, _defineProperty(_classnames, classes.stacked, matches), _defineProperty(_classnames, classes.alignedLeft, alignLeft), _defineProperty(_classnames, classes.autoAligning, hasSecondaryButtons && !disableAutoAlignment), _classnames)),
    ref: ref,
    role: "region"
  }, rest), orderedChildren)));
});
process.env.NODE_ENV !== "production" ? ButtonBar.propTypes = {
  /**
   * By default ButtonBar lays buttons from right to left horizontally ordering action buttons by order prop.
   * Use this prop to lay button from left to right instead.
   * Actions buttons will be ordered by alignLeftOrder prop.
   */
  alignLeft: PropTypes.bool,

  /**
   * A list of OrderButtons
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.element), PropTypes.element]),

  /**
   * The className(s) of the component
   */
  className: PropTypes.string,

  /**
   * @external - material-ui
   */
  classes: PropTypes.objectOf(PropTypes.string),

  /**
   * Density of the DialogActionButtons
   */
  density: PropTypes.oneOf(['touch', 'low', 'medium', 'high']),

  /**
   * By default ButtonBar aligns secondary buttons to the left while displayed horizontally
   * and to the right while aligned left or sorting ascending.
   * Use this prop to disable this behavior.
   */
  disableAutoAlignment: PropTypes.bool,

  /**
   * By default ButtonBar sorts buttons in descending order.
   * Use this prop to change that when the button bar is NOT stacked and aligned left.
   */
  sortAlignLeft: PropTypes.oneOf(['asc', 'desc']),

  /**
   * By default ButtonBar sorts buttons in descending order.
   * Use this prop to change that when the button bar is NOT stacked and NOT aligned left.
   */
  sortOrder: PropTypes.oneOf(['asc', 'desc']),

  /**
   * By default ButtonBar sorts buttons in descending order.
   * Use this prop to change that when the button bar is stacked.
   */
  sortStackOrder: PropTypes.oneOf(['asc', 'desc']),

  /**
   * When the viewport is equal to or smaller than the breakpoint the buttons will be stacked vertically.
   * Alternatively pass a screen width number in pixels.
   * Use `0` to disable this feature. Defaults to 'xs'.
   * Actions buttons will be ordered by stackOrder prop.
   */
  stackAtBreakpoint: PropTypes.oneOfType([PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes.number]),
  theme: PropTypes.objectOf(PropTypes.any)
} : void 0;
export default withStyles(buttonBarStyle, {
  name: 'ButtonBar',
  withTheme: true
})(ButtonBar);